import React from 'react';

function FixUpdateName() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }

    fetch("/fixupdatename", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isFix) {
          alert("הפרטים האישיים עודכנו בהצלחה!");
          window.location = "/";
        } else {
          alert(res.err);
        }
      });
  }

  return (
    <div className="container mt-5" dir="rtl">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h3 className="text-center mb-4">עדכון פרטים אישיים</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">שם פרטי</label>
                <input
                  type="text"
                  name="first_name"
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">שם משפחה</label>
                <input
                  type="text"
                  name="last_name"
                  className="form-control"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label">טלפון</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  required
                />
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  עדכון
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FixUpdateName;
